import { Routes } from "@angular/router";

/**
 * Top-level routes for the home application.
 *
 * One page today. It is the landing spot for a user the queue statistics guard
 * turns away, so it must stay free of permission guards of its own — that is the
 * whole reason it exists rather than the router sending them back to `/`.
 */
export const homeRoutes: Routes = [
  {
    path: "",
    pathMatch: "full",
    loadComponent: () => import("./pages/home/home.component").then(c => c.HomeComponent),
  },
];
